import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DeckVisualizer from '../components/DeckVisualizer';

/**
 * DeckBuilder page - Wrapper for the existing DeckVisualizer component
 * This maintains backward compatibility while enabling the new routing structure
 */
export default function DeckBuilder() {
  const [searchParams] = useSearchParams();
  const loadCode = searchParams.get('load');
  
  return <DeckVisualizer initialDeckCode={loadCode} />;
}
